import React from 'react';
import { Box } from '@mui/material';
import PageHeader from '../components/common/PageHeader';
import ProjectKanbanView from '../components/projects/ProjectKanbanView';

const KanbanPage: React.FC = () => {
  return (
    <Box>
      <PageHeader title="Kanban" breadcrumbs={[{ label: 'Kanban' }]} />
      <ProjectKanbanView />
    </Box>
  );
};

export default KanbanPage;
